import { createFileRoute } from '@tanstack/react-router';

import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute('/admin/_admin')({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  }
});
